import { useContext } from "react";

import { PanelNoticeContext } from "../context/PanelNoticeContext";

/**
 * ======================================================
 * PANEL NOTICE HOOK
 * ======================================================
 */

export function usePanelNotice() {
  const context = useContext(PanelNoticeContext);

  if (!context) {
    throw new Error("usePanelNotice must be used inside PanelNoticeProvider.");
  }

  return context;
}
